import React, { Component } from 'react'
import { Menu, Dropdown, Icon, message } from 'antd';
import instance from '../../service/index'
import './header.less'
import logo from '../../assets/images/login-logo.png'


class HeaderTop extends Component {
	constructor(props){
		super(props)
		this.state = {
			visible: false,
			userName: '',
			showName: false,
		};
	}
	
	componentDidMount() {
		if(localStorage.getItem('user')){
			let userName = JSON.parse(localStorage.getItem('user'))
			this.setState({userName:userName.name,showName: true})	
		}
	}
	logout= ({key})=> {
		if(key === '1') {
			let _this = this
		instance.get('user/logout').then(res=>{
			console.log(res)
			if(res.data.code === '200') {
				// sessionStorage.clear()
				_this.props.history.push('/login')
				message.success('退出登录成功')
				// this.props.history.push('/login')
				// window.location.reload()
			}
		})
		}
		
	}
	render() {
		const onClick = ({ key }) => {
			if(key === '1') {
				
			instance.get('user/logout').then(res=>{
				console.log(res)
				if(res.data.code === '200') {
					sessionStorage.clear()
					localStorage.clear()
					// _this.props.history.push('/login')
					message.success('退出登录成功')
					// this.props.history.push('/login')
					window.location.reload()
				}
			})
			}
		  };
		const menu = (
			<Menu onClick={onClick}>
				<Menu.Item key='1'>
					<span>退出登录</span>
				</Menu.Item>
			</Menu>
		);
		let {showName, userName} = this.state
		return (
			<div className="M-header">
				<div className="l-header">
					<img className="l-logo" src={logo} alt="" />
					<span style={{marginLeft: '20px', fontSize: '18px'}}>芯源学习站管理后台</span>
				</div>
				<div className="r-header">
					{showName&&<Dropdown overlay={menu}>
						<span className="ant-dropdown-link" style={{fontSize: '16px'}} onClick={e => e.preventDefault()}>
							{userName} <Icon style={{fontSize: '12px'}} type="down" />
						</span>
					</Dropdown>}
				</div>
			</div>
		)
	}
}
export default HeaderTop
